import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import {
  canShowBetaToolbar,
  ensureBetaToolbarSession,
  onBetaDisclaimerDismissed,
  onBetaToolbarRouteChange,
  subscribeBetaToolbarEligibility,
} from '../betaToolbarEligibility';
import { SITE_BETA_DISCLAIMER_DISMISSED_KEY } from '../constants/siteDisclaimer';
import { useGaPageView } from '../useGaPageView';
import { BetaBottomToolbar } from './BetaBottomToolbar';
import { BetaPriceNotice } from './BetaPriceNotice';

function cx(...classes) {
  return classes.filter(Boolean).join(' ');
}

function readBetaDisclaimerDismissed() {
  try {
    return localStorage.getItem(SITE_BETA_DISCLAIMER_DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
}

export function AppShell() {
  const { pathname, search } = useLocation();
  const locationKey = `${pathname}${search}`;
  const isHome = pathname === '/';
  const isPreLander = pathname === '/start';
  const isFocusedLanding = isHome || isPreLander;
  const [betaDisclaimerDismissed, setBetaDisclaimerDismissed] = useState(
    readBetaDisclaimerDismissed,
  );
  const [betaToolbarVisible, setBetaToolbarVisible] = useState(() =>
    canShowBetaToolbar(readBetaDisclaimerDismissed()),
  );

  useGaPageView();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    ensureBetaToolbarSession(betaDisclaimerDismissed, locationKey);
    onBetaToolbarRouteChange(locationKey);
    setBetaToolbarVisible(canShowBetaToolbar(betaDisclaimerDismissed));
  }, [betaDisclaimerDismissed, locationKey]);

  useEffect(() => {
    return subscribeBetaToolbarEligibility(() => {
      setBetaToolbarVisible(canShowBetaToolbar(betaDisclaimerDismissed));
    });
  }, [betaDisclaimerDismissed]);

  return (
    <div className={cx('app', isFocusedLanding && 'app--home', isPreLander && 'app--pre-lander')}>
      <Outlet />
      {!isPreLander && (
        <BetaPriceNotice
          dismissed={betaDisclaimerDismissed}
          onDismiss={() => {
            setBetaDisclaimerDismissed(true);
            try {
              localStorage.setItem(SITE_BETA_DISCLAIMER_DISMISSED_KEY, '1');
            } catch {
              /* ignore */
            }
            onBetaDisclaimerDismissed(locationKey);
            setBetaToolbarVisible(canShowBetaToolbar(true));
          }}
        />
      )}
      {!isPreLander && (
        <BetaBottomToolbar visible={betaToolbarVisible} />
      )}
    </div>
  );
}
